import {
  User,
  ServerStat,
  ApiMetric,
  SmsStat,
  BillingStat,
  CitizenStat,
  GeoRegion,
  SystemUser,
  PermissionGroup,
  Permission,
  Service,
  SystemTechInfo,
  VmDetail,
} from '../types'

export const currentUser: User = {
  id: 'u1',
  name: 'Rahim Ahmed',
  email: 'rahim.ahmed@land.gov.bd',
  role: 'Admin',
  avatar:
    'https://ui-avatars.com/api/?name=Rahim+Ahmed&background=0D8ABC&color=fff',
}

export const serverStats: ServerStat[] = [
  {
    id: 's1',
    name: 'Primary App Server',
    status: 'online',
    uptime: '99.99%',
    requestsPerHr: 45000,
    cpuUsage: 45,
    memoryUsage: 60,
    diskUsage: 70,
  },
  {
    id: 's2',
    name: 'Database Cluster',
    status: 'online',
    uptime: '99.95%',
    requestsPerHr: 12000,
    cpuUsage: 30,
    memoryUsage: 55,
    diskUsage: 85,
  },
  {
    id: 's3',
    name: 'API Gateway',
    status: 'degraded',
    uptime: '98.50%',
    requestsPerHr: 85000,
    cpuUsage: 78,
    memoryUsage: 40,
    diskUsage: 20,
  },
  {
    id: 's4',
    name: 'Backup Server',
    status: 'maintenance',
    uptime: '0%',
    requestsPerHr: 0,
    cpuUsage: 5,
    memoryUsage: 10,
    diskUsage: 40,
  },
]

export const apiMetrics: ApiMetric[] = [
  {
    id: 'a1',
    name: 'Khatian Service',
    totalHits: 150000,
    internalHits: 120000,
    externalHits: 30000,
    successRate: 99.2,
    avgResponseTime: 120,
  },
  {
    id: 'a2',
    name: 'Mutation API',
    totalHits: 85000,
    internalHits: 80000,
    externalHits: 5000,
    successRate: 98.5,
    avgResponseTime: 250,
  },
  {
    id: 'a3',
    name: 'Mouza Map',
    totalHits: 45000,
    internalHits: 20000,
    externalHits: 25000,
    successRate: 99.8,
    avgResponseTime: 85,
  },
  {
    id: 'a4',
    name: 'LD Tax',
    totalHits: 210000,
    internalHits: 150000,
    externalHits: 60000,
    successRate: 97.5,
    avgResponseTime: 180,
  },
]

export const smsStats: SmsStat[] = [
  {
    serviceName: 'OTP Verification',
    total: 50000,
    success: 48500,
    failed: 1500,
  },
  {
    serviceName: 'Application Status',
    total: 35000,
    success: 34000,
    failed: 1000,
  },
  {
    serviceName: 'Payment Confirmation',
    total: 28000,
    success: 27500,
    failed: 500,
  },
]

export const billingStats: BillingStat[] = [
  {
    category: 'Khatian Application',
    totalOrders: 691633,
    certifiedCopies: 269342,
    onlineCopies: 422291,
    totalRevenue: 70313650,
    certifiedRevenue: 28164540,
    onlineRevenue: 42229100,
    deliveryMethod: { post: 29859, office: 207751, udc: 0 },
  },
  {
    category: 'Mouza Map',
    totalOrders: 15420,
    certifiedCopies: 12000,
    onlineCopies: 3420,
    totalRevenue: 5400000,
    certifiedRevenue: 4800000,
    onlineRevenue: 600000,
    deliveryMethod: { post: 5000, office: 7000, udc: 0 },
  },
]

export const citizenStats: CitizenStat = {
  totalRegistered: 15420500,
  todayRegistered: 3500,
  nidVerified: 14800000,
  serviceBreakdown: [
    { service: 'Namjari', count: 4500000 },
    { service: 'Land Tax', count: 8200000 },
    { service: 'Porcha', count: 2700000 },
  ],
}

export const geoRegions: GeoRegion[] = [
  {
    id: 'd1',
    name: 'Dhaka',
    type: 'Division',
    stats: {
      applications: 45000,
      revenue: 5000000,
      citizens: 120000,
      resolved: 42000,
    },
  },
  {
    id: 'd2',
    name: 'Chittagong',
    type: 'Division',
    stats: {
      applications: 38000,
      revenue: 4200000,
      citizens: 95000,
      resolved: 35000,
    },
  },
  {
    id: 'd3',
    name: 'Rajshahi',
    type: 'Division',
    stats: {
      applications: 25000,
      revenue: 2800000,
      citizens: 70000,
      resolved: 23000,
    },
  },
  {
    id: 'd4',
    name: 'Khulna',
    type: 'Division',
    stats: {
      applications: 22000,
      revenue: 2500000,
      citizens: 65000,
      resolved: 20000,
    },
  },
]

// Mock Data for User Management
export const permissionGroups: PermissionGroup[] = [
  {
    id: 'pg1',
    name: 'সুপার অ্যাডমিন',
    name_en: 'Super Admin',
    permissions: ['all'],
  },
  {
    id: 'pg2',
    name: 'অ্যাডমিন',
    name_en: 'Admin',
    permissions: ['view_dashboard', 'manage_users', 'view_reports'],
  },
  {
    id: 'pg3',
    name: 'ম্যানেজার',
    name_en: 'Manager',
    permissions: ['view_dashboard', 'view_reports'],
  },
  {
    id: 'pg4',
    name: 'ভিউয়ার',
    name_en: 'Viewer',
    permissions: ['view_dashboard'],
  },
]

export const permissions: Permission[] = [
  // Dashboard Module
  {
    id: 'p1',
    name: 'ড্যাশবোর্ড দেখুন',
    name_en: 'View Dashboard',
    permission_key: 'view_dashboard',
    module: 'Dashboard',
  },
  {
    id: 'p2',
    name: 'টেকনিক্যাল ড্যাশবোর্ড দেখুন',
    name_en: 'View Technical Dashboard',
    permission_key: 'view_technical_dashboard',
    module: 'Dashboard',
  },
  {
    id: 'p3',
    name: 'পলিসি ড্যাশবোর্ড দেখুন',
    name_en: 'View Policy Dashboard',
    permission_key: 'view_policy_dashboard',
    module: 'Dashboard',
  },

  // Users Module
  {
    id: 'p4',
    name: 'ব্যবহারকারী দেখুন',
    name_en: 'View Users',
    permission_key: 'view_users',
    module: 'Users',
  },
  {
    id: 'p5',
    name: 'ব্যবহারকারী তৈরি করুন',
    name_en: 'Create User',
    permission_key: 'create_user',
    module: 'Users',
  },
  {
    id: 'p6',
    name: 'ব্যবহারকারী সম্পাদনা করুন',
    name_en: 'Edit User',
    permission_key: 'edit_user',
    module: 'Users',
  },
  {
    id: 'p7',
    name: 'ব্যবহারকারী মুছুন',
    name_en: 'Delete User',
    permission_key: 'delete_user',
    module: 'Users',
  },

  // Roles Module
  {
    id: 'p8',
    name: 'রোল দেখুন',
    name_en: 'View Roles',
    permission_key: 'view_roles',
    module: 'Roles',
  },
  {
    id: 'p9',
    name: 'রোল তৈরি করুন',
    name_en: 'Create Role',
    permission_key: 'create_role',
    module: 'Roles',
  },
  {
    id: 'p10',
    name: 'রোল সম্পাদনা করুন',
    name_en: 'Edit Role',
    permission_key: 'edit_role',
    module: 'Roles',
  },

  // Reports Module
  {
    id: 'p11',
    name: 'রিপোর্ট দেখুন',
    name_en: 'View Reports',
    permission_key: 'view_reports',
    module: 'Reports',
  },
  {
    id: 'p12',
    name: 'রিপোর্ট ডাউনলোড করুন',
    name_en: 'Download Reports',
    permission_key: 'download_reports',
    module: 'Reports',
  },

  // Settings Module
  {
    id: 'p13',
    name: 'সেটিংস দেখুন',
    name_en: 'View Settings',
    permission_key: 'view_settings',
    module: 'Settings',
  },
  {
    id: 'p14',
    name: 'সেটিংস পরিবর্তন করুন',
    name_en: 'Manage Settings',
    permission_key: 'manage_settings',
    module: 'Settings',
  },
]

export const systemUsers: SystemUser[] = [
  {
    id: 'u1',
    name: 'করিম হাসান',
    name_en: 'Karim Hasan',
    mobile: '01711111111',
    email: 'karim@land.gov.bd',
    username: 'karim_admin',
    permission_group_id: 'pg1',
    status: 'active',
    created_at: '2023-01-15',
  },
  {
    id: 'u2',
    name: 'রহিম উদ্দিন',
    name_en: 'Rahim Uddin',
    mobile: '01722222222',
    email: 'rahim@land.gov.bd',
    username: 'rahim_manager',
    permission_group_id: 'pg2',
    status: 'active',
    created_at: '2023-02-20',
  },
  {
    id: 'u3',
    name: 'সালমা খাতুন',
    name_en: 'Salma Khatun',
    mobile: '01733333333',
    email: 'salma@land.gov.bd',
    username: 'salma_tech',
    permission_group_id: 'pg3',
    status: 'active',
    created_at: '2023-03-10',
  },
  {
    id: 'u4',
    name: 'জামাল হোসেন',
    name_en: 'Jamal Hossain',
    mobile: '01744444444',
    email: 'jamal@land.gov.bd',
    username: 'jamal_viewer',
    permission_group_id: 'pg4',
    status: 'inactive',
    created_at: '2023-04-05',
  },
  {
    id: 'u5',
    name: 'নাসরিন আক্তার',
    name_en: 'Nasrin Akter',
    mobile: '01755555555',
    email: 'nasrin@land.gov.bd',
    username: 'nasrin_policy',
    permission_group_id: 'pg2',
    status: 'active',
    created_at: '2023-05-12',
  },
  {
    id: 'u6',
    name: 'রফিকুল ইসলাম',
    name_en: 'Rafiqul Islam',
    mobile: '01766666666',
    email: 'rafiqul@land.gov.bd',
    username: 'rafiqul_div',
    permission_group_id: 'pg3',
    status: 'active',
    created_at: '2023-06-18',
  },
  {
    id: 'u7',
    name: 'ফারজানা ইয়াসমিন',
    name_en: 'Farjana Yasmin',
    mobile: '01777777777',
    email: 'farjana@land.gov.bd',
    username: 'farjana_dist',
    permission_group_id: 'pg3',
    status: 'active',
    created_at: '2023-07-22',
  },
  {
    id: 'u8',
    name: 'আব্দুল মালেক',
    name_en: 'Abdul Malek',
    mobile: '01788888888',
    email: 'malek@land.gov.bd',
    username: 'malek_upz',
    permission_group_id: 'pg4',
    status: 'active',
    created_at: '2023-08-30',
  },
]

// Services Mock Data
export const services: Service[] = [
  {
    id: 's1',
    name: 'ডিএলআরএমএস',
    name_en: 'DLRMS',
    has_billing: true,
    row_status: 'active',
    uuid: 'dlrms-uuid-001',
  },
  {
    id: 's2',
    name: 'ই-নামজারি',
    name_en: 'E-Namjari',
    has_billing: true,
    row_status: 'active',
    uuid: 'enamjari-uuid-002',
  },
  {
    id: 's3',
    name: 'ভূমি কর',
    name_en: 'Land Tax',
    has_billing: true,
    row_status: 'active',
    uuid: 'landtax-uuid-003',
  },
  {
    id: 's4',
    name: 'মৌজা ম্যাপ',
    name_en: 'Mouza Map',
    has_billing: false,
    row_status: 'active',
    uuid: 'mouzamap-uuid-004',
  },
  {
    id: 's5',
    name: 'এসএসও সার্ভিস',
    name_en: 'SSO Service',
    has_billing: false,
    row_status: 'active',
    uuid: 'sso-uuid-005',
  },
  {
    id: 's6',
    name: 'এসএমএস গেটওয়ে',
    name_en: 'SMS Gateway',
    has_billing: false,
    row_status: 'inactive',
    uuid: 'sms-uuid-006',
  },
]

export const systemTechInfos: Record<string, SystemTechInfo> = {
  'dlrms-uuid-001': {
    service_uuid: 'dlrms-uuid-001',
    totalVm: 12,
    totalRunning: 11,
    totalDown: 1,
    totalContainer: 45,
    totalPod: 42,
    activePod: 40,
    alerts: [
      {
        id: 'alt1',
        severity: 'critical',
        message: 'High CPU usage on DB Node 2',
        timestamp: '2024-02-20T10:30:00Z',
      },
      {
        id: 'alt2',
        severity: 'warning',
        message: 'Memory threshold reached on App Server 1',
        timestamp: '2024-02-20T09:15:00Z',
      },
    ],
  },
  'enamjari-uuid-002': {
    service_uuid: 'enamjari-uuid-002',
    totalVm: 8,
    totalRunning: 8,
    totalDown: 0,
    totalContainer: 24,
    totalPod: 24,
    activePod: 24,
    alerts: [],
  },
  'landtax-uuid-003': {
    service_uuid: 'landtax-uuid-003',
    totalVm: 15,
    totalRunning: 14,
    totalDown: 1,
    totalContainer: 60,
    totalPod: 58,
    activePod: 55,
    alerts: [
      {
        id: 'alt3',
        severity: 'info',
        message: 'Scheduled maintenance upcoming',
        timestamp: '2024-02-21T00:00:00Z',
      },
    ],
  },
  'mouzamap-uuid-004': {
    service_uuid: 'mouzamap-uuid-004',
    totalVm: 4,
    totalRunning: 4,
    totalDown: 0,
    totalContainer: 12,
    totalPod: 12,
    activePod: 12,
    alerts: [],
  },
  'sso-uuid-005': {
    service_uuid: 'sso-uuid-005',
    totalVm: 6,
    totalRunning: 6,
    totalDown: 0,
    totalContainer: 18,
    totalPod: 18,
    activePod: 18,
    alerts: [],
  },
}

export const vmDetails: VmDetail[] = [
  {
    id: 'vm1',
    name: 'app-server-01',
    status: 'running',
    cpu: 45,
    memory: 60,
    disk: 70,
    uptime: '15d 4h',
  },
  {
    id: 'vm2',
    name: 'app-server-02',
    status: 'running',
    cpu: 32,
    memory: 55,
    disk: 68,
    uptime: '15d 4h',
  },
  {
    id: 'vm3',
    name: 'db-node-01',
    status: 'running',
    cpu: 65,
    memory: 80,
    disk: 85,
    uptime: '45d 12h',
  },
  {
    id: 'vm4',
    name: 'db-node-02',
    status: 'error',
    cpu: 0,
    memory: 0,
    disk: 0,
    uptime: '0m',
  },
  {
    id: 'vm5',
    name: 'cache-redis',
    status: 'running',
    cpu: 15,
    memory: 40,
    disk: 30,
    uptime: '20d 6h',
  },
]
